import { DenormalizedCustomizableQuestion } from '@packages/types'
import React from 'react'

import useThemeSettings from 'customizer/theme/useThemeSettings'

import MultiAnswerSelectionsMessage from './../questions/MultiAnswerSelectionsMessage'
import Translation from '../Translation'

export type SummaryDrawerQuestionMessageProps = {
  question: DenormalizedCustomizableQuestion
  isOutOfStock?: boolean
  hasError?: boolean
  visited?: boolean
}

const SummaryDrawerQuestionMessage = ({
  question,
  isOutOfStock,
  hasError,
  visited,
}: SummaryDrawerQuestionMessageProps) => {
  const questionPanelStyle = useThemeSettings('questionPanel')
  const summaryDrawerStyle = useThemeSettings('summaryDrawer')

  if (isOutOfStock) {
    return (
      <Translation
        field="outOfStock"
        className="summary-drawer__step-message"
        style={{ color: questionPanelStyle.errorColor }}
      />
    )
  }

  if (question.hasFilteredWord) {
    return (
      <Translation
        className="summary-drawer__step-message"
        field="wordFilter"
        style={{ color: questionPanelStyle.errorColor }}
      />
    )
  }

  if (question.isMultiAnswer && (!visited || hasError)) {
    return (
      <MultiAnswerSelectionsMessage
        className="summary-drawer__step-message"
        question={question}
        style={{ color: hasError ? questionPanelStyle.errorColor : summaryDrawerStyle.answerColor }}
      />
    )
  }

  return null
}

export default SummaryDrawerQuestionMessage
